import React from "react";
import { Heading, IconOnePass, Link, LinkButton, Span, Text, } from "@catchoftheday/cg-components";
import { DEFAULT_FREE_TRIAL_DAYS, URL_ONEPASS_LANDING } from "../../../consts";
import { ContentZone } from "../../layouts/UpsellModalLayout/UpsellModalLayout";
import { OnePassModal } from "../OnePassModal";
import { UpsellSecondaryCTA, } from "../UpsellSecondaryCTA";
import { Benefits } from "./Benefits";
import { DivisionIcons } from "./DivisionIcons";
import { Pricing } from "./Pricing";
export const UpsellModal = ({ isOpen = false, onClose, isFreeTrialEligible, showSecondaryCTA, mainCTAHref, onMainCTAClick, onLearnMoreClick, isLoggedIn, ...secondaryCTAProps }) => {
    return (<OnePassModal sizeVariant={{ xs: "x-small", md: "small" }} isOpen={isOpen} onRequestClose={onClose}>
      <ContentZone>
        <Heading.h2 fontWeight="bold" m={0}>
          Join
          <IconOnePass height="1em" width="auto" color="onePass.primary" aria-label="OnePass" mt={-2} ml={1}/>
        </Heading.h2>
        <Text fontSize="base" fontWeight="medium" textAlign="center" my={4}>
          Enjoy a range of benefits from your favourite retail brands.
        </Text>
        <DivisionIcons />
        <Benefits />
        <Pricing />

        <Span fontSize={{ xs: "xs", md: "base" }} fontWeight="medium" textAlign="center" color="textTertiary">
          Cancel anytime.{" "}
          {isFreeTrialEligible && "Billing starts at end of trial."}
        </Span>

        <LinkButton mt={4} href={mainCTAHref} variant="onePassPrimary" sizeVariant="md" fontWeight="semibold" textTransform="uppercase" whiteSpace="wrap" onClick={onMainCTAClick}>
          {isFreeTrialEligible
            ? `Start free ${DEFAULT_FREE_TRIAL_DAYS} day trial`
            : "Join OnePass today"}
        </LinkButton>

        {showSecondaryCTA && (<UpsellSecondaryCTA isLoggedIn={isLoggedIn} {...secondaryCTAProps}/>)}
        <Link fontWeight="bold" fontSize="xs" mt={4} color="onePass.primary" href={URL_ONEPASS_LANDING} target="_blank" textTransform="capitalize" textDecoration="underline" onClick={onLearnMoreClick}>
          Learn more
        </Link>
      </ContentZone>
    </OnePassModal>);
};
